import React from 'react';
import type { Participation, ParticipationType } from 'app/types';
import type { ParticipationFormValues } from '../../../EmployeeIncomeParticipations.types';

export const useParticipationFormInitialValues = (
  isEdit: boolean,
  participation: Participation | null,
  availableTypes: ParticipationType[],
) => {
  const defaultType: ParticipationType | '' = availableTypes.length === 1 ? availableTypes[0] : '';

  const formikInitialValues = React.useMemo<ParticipationFormValues>(() => {
    if (isEdit) {
      return {
        startDate: participation!.startDate,
        endDate: participation!.endDate ?? null,
        type: participation!.type,
        reasonStart: participation!.reasonStart,
        reasonEnd: participation!.reasonEnd ?? '',
      };
    }
    return {
      startDate: null,
      endDate: null,
      type: defaultType,
      reasonStart: '',
      reasonEnd: '',
    };
  }, [isEdit, participation, defaultType]);

  return { formikInitialValues };
};
